// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import extensionSnippetEntity from './entities/extension-snippet.json';
import extensionSnippetMenu from '../pages/extension-snippet/menu.json';
import extensionSnippetFullForm from '../pages/extension-snippet/forms/full.json';
import extensionSnippetContextForm from '../pages/extension-snippet/forms/context.json';
import extensionSnippetMiniForm from '../pages/extension-snippet/forms/mini.json';
import extensionSnippetLookupForm from '../pages/extension-snippet/forms/lookup.json';
import extensionSnippetTableView from '../pages/extension-snippet/views/table.json';
import extensionSnippetCardsView from '../pages/extension-snippet/views/cards.json';
import extensionSnippetDashboardView from '../pages/extension-snippet/views/dashboard.json';

/** Тип запису «Фрагмент» зі сторінками пакета: меню, форми та подання з pages/extension-snippet/. */
export const extensionSnippetDefinition: IRecordTypeDefinition = {
  ...extensionSnippetEntity,
  views: assembleViewSet({
      table: extensionSnippetTableView,
      cards: extensionSnippetCardsView,
      dashboard: extensionSnippetDashboardView,
  }),
  form: extensionSnippetFullForm,
  forms: { full: extensionSnippetFullForm, context: extensionSnippetContextForm, mini: extensionSnippetMiniForm, lookup: extensionSnippetLookupForm },
  menu: extensionSnippetMenu,
} as IRecordTypeDefinition;
